import React, { useEffect, useState } from 'react';
import { ContactContainer, InnerContainer, Left, Popup, Right } from './Styled';
import ContactIcon from '../../Assets/Contacticon.svg';
import { FaPhoneAlt } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { send } from 'emailjs-com';

const Index = () => {

    const [toSend, setToSend] = useState({
        name: '',
        contact: '',
        subject: '',
        message: '',
    });
    const [toast, setToast] = useState({});
    const handleChange = (e) => {
        setToSend({ ...toSend, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let answer = {
            from_name: toSend?.name,
            contact: toSend?.contact,
            message: toSend?.message,
        };
        send(
            'service_76t3s9g',
            'template_jebaz21',
            answer,
            'ku17S8pYK2spUCjF8'
        )
            .then((response) => {
                setToast({ show: true, message: ' Thanks for dropping a message! I’ll reach out as soon as possible.', color: '#02A4D3' });
                setToSend({
                    name: '',
                    contact: '',
                    message: '',
                    subject: ''
                });

            })
            .catch((err) => {
                setToast({ show: true, message: 'Oops Something bad!! Please try again later', color: '#02A4D3' });
            });
    };

    useEffect(() => {
        setTimeout(() => setToast({
            show: false,
            message: ""
        }), 5000)

    }, [toast?.show]);


    return (
        <ContactContainer>
            <InnerContainer>
                {toast?.show && <Popup color={toast?.color}>
                    <p>{toast?.message}</p>
                </Popup>}

                <img src={ContactIcon} />
                <Left>
                    <h2>Get in touch</h2>
                    <p>I'm very approachable and love to speak to you. Feel free to call, send an email. Follow me in the social media or simply complete the enquiry form.</p>

                    <div>
                        <h5><span><FaPhoneAlt /></span> +1 (647) 284 3632</h5>
                        <h5><span><MdEmail /></span> goel6004@gmail.com</h5>

                    </div>
                </Left>
                <Right>
                    <h2>Send me a message</h2>

                    <form onSubmit={handleSubmit}>

                        <input name="name"
                            type="text"
                            placeholder='Name'
                            value={toSend.name}
                            onChange={handleChange}
                            required />

                        <input name="contact"
                            type="email"
                            placeholder='Email Address'
                            value={toSend.contact}
                            onChange={handleChange}
                            required />

                        <input name="subject"
                            type="text"
                            placeholder='Subject'
                            value={toSend.subject}
                            onChange={handleChange}
                            required />

                        <textarea name="message"
                            type="text"
                            placeholder='Your message'
                            value={toSend.message}
                            onChange={handleChange}
                            required />

                        <div>
                            <input type="hidden" name="_subject" value="New submission!" />
                            <input type="hidden" name="_captcha" value="false" />
                            <button type="submit" > Send Message  </button>
                        </div >
                    </form>
                </Right>
            </InnerContainer>
        </ContactContainer>
    );
}

export default Index;
